import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';

class LocationService {
  constructor(locationApiUrl, defaultConfig, getCustomAccessToken) {
    this.getProvinces = async () => {
      return this.locationApi.get("/location/provinces").then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.provinces);
      });
    };
    this.getDistrictsByProvinceCode = async (provinceCode) => {
      return this.locationApi.get(`/location/districts?provinceCode=${provinceCode}`).then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.districts);
      });
    };
    this.getWardsByDistrictCode = async (districtCode) => {
      return this.locationApi.get(`/location/wards?districtCode=${districtCode}`).then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.wards);
      });
    };
    this.getAddressSuggestions = async (params) => {
      return this.locationApi.get("/location/addresses/suggest", { params }).then((res) => {
        var _a, _b;
        return ((_b = (_a = res.data) == null ? void 0 : _a.data) == null ? void 0 : _b.addresses) || [];
      });
    };
    this.locationApi = new Api(locationApiUrl, void 0, defaultConfig);
    if (typeof getCustomAccessToken === "function") {
      this.locationApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.locationApi.addInterceptor(accessTokenInterceptor);
    }
  }
}

export { LocationService };
